export const CA_UPDATE_STATE = "CA_UPDATE_STATE"
